var _circle, _path, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpirence2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 56,
    fill: "url(#paint0_angular_22302_13251)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95 66.5H92V65C91.9991 64.2046 91.6827 63.4421 91.1203 62.8797C90.5579 62.3173 89.7954 62.0009 89 62H71C70.2046 62.0009 69.4421 62.3173 68.8797 62.8797C68.3173 63.4421 68.0009 64.2046 68 65V66.5H65C64.2046 66.5009 63.4421 66.8173 62.8797 67.3797C62.3173 67.9421 62.0009 68.7046 62 69.5V74C62.0018 75.5908 62.6345 77.1158 63.7593 78.2407C64.8842 79.3655 66.4092 79.9982 68 80H68.483C69.108 82.2961 70.3881 84.3605 72.1669 85.9412C73.9457 87.5219 76.1463 88.5504 78.5 88.9011V95H71V98H89V95H81.5V88.8967C83.8842 88.6019 86.1242 87.5953 87.9277 86.0082C89.7312 84.4212 91.0145 82.3274 91.61 80H92C93.5907 79.9982 95.1158 79.3655 96.2407 78.2407C97.3655 77.1158 97.9982 75.5908 98 74V69.5C97.9991 68.7046 97.6827 67.9421 97.1203 67.3797C96.5579 66.8173 95.7954 66.5009 95 66.5ZM68 77C67.2046 76.9991 66.4421 76.6827 65.8797 76.1203C65.3173 75.5579 65.0009 74.7954 65 74V69.5H68V77ZM89 77C89 78.2053 88.7579 79.3983 88.288 80.5083C87.8182 81.6183 87.1302 82.6226 86.2648 83.4616C85.3994 84.3006 84.3744 84.9572 83.2504 85.3925C82.1264 85.8278 80.9265 86.0329 79.7218 85.9957C77.333 85.8475 75.0934 84.784 73.4689 83.0265C71.8444 81.269 70.9601 78.9527 71 76.5597V65H89V77ZM95 74C94.9991 74.7954 94.6827 75.5579 94.1203 76.1203C93.5579 76.6827 92.7954 76.9991 92 77V69.5H95V74Z",
    fill: "#063963"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 158,
    height: 158,
    rx: 79,
    stroke: "#22B8CF",
    strokeOpacity: 0.24,
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_22302_13251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(80 80) rotate(-180) scale(56)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22B8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77F0ED"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpirence2);
export default __webpack_public_path__ + "static/media/expirence2.6aeacc4035bf548737da23d3df1888eb.svg";
export { ForwardRef as ReactComponent };